import React, { useEffect, useRef, useState } from 'react';
import loadable from '@loadable/component';

import LeftArrow from './images/left-arrow.svg';
import RightArrow from './images/right-arrow.svg';

import css from './SectionBestMatch.module.css';
import { ListingCard } from '../../../../components';

const Swiper =
  typeof window !== 'undefined'
    ? require('swiper/react').Swiper
    : loadable(() => import('swiper/react'), {
        ssr: false,
      });
const SwiperSlide =
  typeof window !== 'undefined'
    ? require('swiper/react').SwiperSlide
    : loadable(() => import('swiper/react'), {
        ssr: false,
      });
const Navigation =
  typeof window !== 'undefined'
    ? require('swiper/modules').Navigation
    : loadable(() => import('swiper/modules'), {
        ssr: false,
      });

const SectionBestMatch = props => {
  const {
    listings,
    config,
    _queryBestMatchListingsError,
    _queryBestMatchListingsInProgress,
    onQueryBestMatchListings,
  } = props;
  const swiperRef = useRef();
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  const [currentSlideIndex, setCurrentSlideIndex] = useState(1);
  const [totalSlides, setTotalSlides] = useState(0);
  
  useEffect(() => {
    // Load swiper CSS only in the browser
    if (typeof window !== 'undefined') {
      require('swiper/css/bundle');
      require('swiper/css/navigation');
    }

    if (!listings) {
      onQueryBestMatchListings(config);
    }
  }, []);

  useEffect(() => {
    setTotalSlides(listings?.length ?? 0);
  }, [listings]);

  const _numerOfListeners = 30;

  const cardRenderSizes = () => {
    return [
      '(max-width: 549px) 100vw',
      '(max-width: 767px) 50vw',
      `(max-width: 1439px) 26vw`,
      `(max-width: 1920px) 18vw`,
      `14vw`,
    ].join(', ');
  };

  return (
    <div className={css.root}>
      <div className={css.headingContainer}>
        <div className={css.heading}>Best match for you</div>
        <div className={css.slidesCounter}>
          <img
            src={LeftArrow}
            className="hover"
            onClick={() => {
              if (swiperRef) {
                swiperRef.current.swiper.slidePrev();
              }
            }}
          />
          {`${currentSlideIndex} / ${totalSlides}`}
          <img
            src={RightArrow}
            className="hover"
            onClick={() => {
              if (swiperRef) {
                swiperRef.current.swiper.slideNext();
              }
            }}
          />
        </div>
      </div>
      <div className={css.sliderContainer}>
        <Swiper
          className={css.swiper}
          ref={swiperRef}
          slidesPerView={isMobile ? 1 : 4}
          spaceBetween={20}
          modules={[Navigation]}
          loop={true}
          onSwiper={swiper => {
            // Initialize the current slide index when swiper is first created
            // Default to 1 if realIndex is not available
            if (swiper && typeof swiper.realIndex === 'number') {
              setCurrentSlideIndex(swiper.realIndex + 1);
            } else {
              setCurrentSlideIndex(1);
            }
          }}
          onSlideChange={swiper => {
            // In loop mode, realIndex gives us the actual slide index (0-based)
            // We add 1 to make it 1-based for display
            const newIndex = typeof swiper.realIndex === 'number' ? swiper.realIndex + 1 : 1;
            setCurrentSlideIndex(newIndex);
          }}
        >
          {listings?.map((l, index) => (
            <SwiperSlide key={index}>
              <ListingCard
                className={css.listingCard}
                key={l.id.uuid}
                listing={l}
                renderSizes={cardRenderSizes()}
              />
              {/* <div className={css.slideContainer}>
                                <div className={css.imageContainer} style={{
                                    // backgroundImage: `url(${slide.image})`
                                }}>
                                    <div className={css.topSvg} style={slide.diamondType === GoldDiamond ? { backgroundColor: "#FFE885" } : null}>
                                        <img src={slide.diamondType} />
                                    </div>
                                    <div className={css.listeners}>
                                        {numerOfListeners}
                                        <img src={slide.microphoneType} />
                                    </div>

                                    <AspectRatioWrapper
                                        className={css.aspectRatioWrapper}
                                        width={aspectWidth}
                                        height={aspectHeight}
                                        {...setActivePropsMaybe}
                                    >
                                        <LazyImage
                                            rootClassName={css.rootForImage}
                                            alt={title}
                                            image={firstImage}
                                            variants={variants}
                                            sizes={renderSizes}
                                        />
                                    </AspectRatioWrapper>

                                </div>
                                <div className={css.slideContent}>
                                    <p className={css.name}>{slide.fullName}</p>
                                    <p className={css.position}>{slide.headline}</p>
                                    <p className={css.description}>{slide.bio}</p>
                                    <div className={css.slideFooter}>
                                        <div className={css.tagsContainer}>
                                            {slide.tags?.map((tag, tagIndex) => (
                                                <span className={css.tag} key={tagIndex}>{tag}</span>
                                            ))}
                                        </div>
                                        <a className={css.link}>
                                            <img src={GrayArrow} />
                                        </a>
                                    </div>


                                </div>

                            </div> */}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default SectionBestMatch;
